module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [(_vm.showFooterInfo) ? _c('section', {
    staticClass: "footer__company-info"
  }, [_c('div', {
    staticClass: "footer__container"
  })]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "footer__copyright"
  }, [_c('div', {
    staticClass: "footer__container text-center"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "onclick": "javascript:window.open('https://beian.miit.gov.cn/');"
    }
  }, [_vm._v(_vm._s(_vm.companyInfo.name))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b75fe5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = 1065
// module chunks = 1